import { styled } from 'styled-components';
import { Styling } from '@/styling';

export const Code = styled.div`
  ${Styling.typography('body')}
  padding: 16px;
  color: #4d4d4d;
  background-color: ${({ theme }) => theme.palette.grayscale.light5};
  border-radius: 4px;
  border: 1px solid #e9e9e9;
  overflow: auto;
`;

export const InlineCode = styled.span`
  ${Styling.typography('body')}
  padding: 2px;
  margin: 0 2px 0 2px;
  color: #4d4d4d;
  background-color: ${({ theme }) => theme.palette.grayscale.light5};
  border-radius: 4px;
  border: 1px solid #e9e9e9;
  overflow: auto;
`;
